








































































































import url from "@/mixins/analytics/url";
import AlertItem from "@/components/AlertItem.vue";
import AlertsAdd from "@/components/AlertsAdd.vue";
import AlertsDeliveryConfig from "@/components/AlertsDeliveryConfig.vue";
import HeadingButtons from "@/components/HeadingButtons.vue";
import HeadingInline from "@/components/HeadingInline.vue";
import { Alert, DeliveryConfig } from "@/types/alert";
import { Features } from "@/types/settings";
import { Component, Mixins } from "vue-property-decorator";
import { State, Getter } from "vuex-class";

@Component({
  components: {
    AlertItem,
    AlertsAdd,
    HeadingButtons,
    HeadingInline,
    AlertsDeliveryConfig,
  },
})
export default class AlertsView extends Mixins(url) {
  created() {
    // Simple caching
    // The more elaborate `fetch, fetching, fetched...` strategy is overkill here
    if (!this.alerts) {
      this.$store.dispatch("alerts/fetch");
    }
  }

  @State(state => state.token) token!: string;
  @State(state => state.alerts.alerts) alerts!: Alert[];
  @State(state => state.alerts.deliveryConfigs)
  deliveryConfigs!: DeliveryConfig[];
  @State(state => state.alerts.showAddDeliveryConfig)
  showAddDeliveryConfig!: boolean;

  @Getter("settings/activeCacheFeatures") features!: Features;

  showAddAlert = false;

  get alertLimit() {
    return this.features["alert-limit"] as number;
  }

  get canAddAlerts() {
    return this.alertLimit !== 0;
  }

  get hasDeliveryConfigs() {
    return this.deliveryConfigs && this.deliveryConfigs.length > 0;
  }

  get hasAlerts() {
    return this.alerts && this.alerts.length > 0;
  }

  get showFirstDeliveryConfigCard() {
    return (
      this.deliveryConfigs && // if delivery configs fetched
      this.canAddAlerts &&
      !this.hasDeliveryConfigs &&
      !this.showAddDeliveryConfig
    );
  }

  get showFirstAlertCard() {
    return (
      this.canAddAlerts &&
      this.hasDeliveryConfigs && // do not show if has 0 delivery configs
      !this.showAddAlert &&
      !this.hasAlerts
    );
  }

  get alertUsage() {
    const alertLen = this.alerts ? this.alerts.length : 0;
    return `${alertLen}/${this.alertLimit}`;
  }

  get alertLimitReached() {
    return this.alertLimit !== -1 && this.alerts && this.alerts.length >= this.alertLimit;
  }

  get previewAlerts(): Alert[] {
    return [
      {
        id: 0,
        trigger_type: "hit_rate",
        trigger_threshold: 70,
        delivery_config_id: 0,
        description: "",
        enabled: true,
      },
      {
        id: 1,
        trigger_type: "memory_usage",
        trigger_threshold: 85,
        delivery_config_id: 0,
        description: "",
        enabled: true,
      },
    ];
  }

  toggleAddDeliveryConfig() {
    const toggle = this.showAddDeliveryConfig ? "Hide" : "Show";
    this.$ga.toggle(`${toggle} add delivery config`);
    this.$store.dispatch("alerts/setShowAddDeliveryConfig", !this.showAddDeliveryConfig);
  }

  toggleAddAlert() {
    this.showAddAlert = !this.showAddAlert;
  }
}
